import React, { useState } from "react";
import {} from "../../GenAIPrompts/GenAIPrompts";
import "./WordsToDescribe.module.css";
import { callOpenAI } from "../../API/API";

const WordsToDescribe: React.FC = () => {
  return <div>Fill In The Blank Component Placeholder</div>;
};

export default WordsToDescribe;
